import { Link } from "react-router";
export default function EmptyContent({ title, description }) {
  return (
    <div className="col-span-full text-center flex justify-center mb-6">
      <div className="max-w-xl rounded-xl bg-white p-8 text-center shadow-md">
        <h2 className="text-2xl font-bold text-gray-900">Coming soon!</h2>

        <p className="mt-4 mb-4 text-pretty text-gray-700">{description}</p>

        <button className="inline-block rounded-sm bg-[#0166b1] px-12 py-3 text-sm font-medium text-white transition hover:bg-emerald-700 focus:ring-2 focus:ring-yellow-400 focus:outline-hidden">
          <Link to="/registration">Register Here</Link>
        </button>

        <p className="mt-6 text-sm text-gray-700">
          Registered users will be notified once {title} is available.
        </p>
      </div>
    </div>
  );
}
